import classNames from "classnames/bind";
import { type NavigationLink } from "./AppNavigation";

import { NavLink } from "react-router-dom";
import styles from "./AppNavigation.module.scss";

const cx = classNames.bind(styles);

export interface Props {
  link: NavigationLink;
  disabled?: boolean;
}

export const AppNavigationLink: React.FC<Props> = ({ link, disabled }) => {
  const text = (
    <span
      className={cx(styles.linkText, {
        [styles.disabledText]: disabled,
      })}
    >
      {link.label}
    </span>
  );

  if (disabled) {
    return <div className={styles.navigationItem}>{text}</div>;
  }

  const isActiveLink = window.location.pathname === link.to;

  return isActiveLink ? (
    <div className={cx("active", styles.navigationItem)}>{text}</div>
  ) : (
    <NavLink to={link.to} className={styles.navigationItem}>
      {text}
    </NavLink>
  );
};
